import React, {  useMemo, useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';


import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import '@ag-grid-community/core/dist/styles/ag-theme-alpine.css';

import { cs2Actions } from '../_actions';

function FileUploadLogs() {
	
	const gridStyle = useMemo(() => ({ height: '600px', width: '100%' }), []);
    const [rowData, setRowData] = useState();
    const modules = useMemo(() => [ClientSideRowModelModule], []);
    const requestLog = useSelector(state => state.cs2FileLog);
    
    const dispatch = useDispatch();
     

    useEffect(() => {
        dispatch(cs2Actions.cs2SubmissionLog());
    }, []);
      
    const [columnDefs, setColumnDefs] = useState([
  	  { field: 'reqSubmissionId', headerName: 'Transaction ID', filter: 'agTextColumnFilter' },
  	  { field: 'reqDate', headerName: 'Received Date', filter: 'agTextColumnFilter'},
 	  { field: 'reqDate', headerName: 'Start Time', filter: 'agTextColumnFilter'},
 	  { field: 'reqEndDate', headerName: 'Completed Time', filter: 'agTextColumnFilter'},
 	  { field: 'status', width: 300, filter: 'agTextColumnFilter'},
  	  { field: 'description', width: 300, filter: 'agTextColumnFilter' },
  	  //{ field: 'updateTS', headerName: 'NYSE Dollars'   },	  
    ]); 

    const defaultColDef = useMemo(() => {
        return {
          width: 184,
          sortable: true,
          resizable: true,
          wrapText: true,
          autoHeight: true,
        };
      }, []);

    return (
	  		<div>
	  		<div className="row">
	    		<div className="col-md-8" >
	    			<h3>CS2 Request Logs</h3>
	    		</div>
    		</div>
    	
			      <div style={gridStyle} className="ag-theme-alpine">
			        <AgGridReact
			          rowData={ requestLog.items }
			          modules={modules}
			          columnDefs={columnDefs}
			          defaultColDef={defaultColDef}
			        ></AgGridReact>
			      </div>

		</div>

    );
}

export { FileUploadLogs };